export const VALID_DATA = '1w 1m';

export const INVALID_DATA = 'Invalid data';

export const DATA_TEST_ID_PREFIX = 'issue-time-estimate.ui.edit.';
